export { BaseTooltip } from './ToolTip'
export type { BaseTooltipProps } from './ToolTip'
